import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import LandingTest from "./pages/LandingTest";
import LandingV3 from "./pages/LandingV3";
import OracoesIndex from "./pages/OracoesIndex";
import PrayerPage from "./pages/PrayerPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminConversions from "./pages/AdminConversions";
import Privacidade from "./pages/Privacidade";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <span className="font-serif-display italic text-[#9C877A]">Carregando...</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function LegacyPrayerRedirect() {
  const { number } = useParams();
  return <Navigate to={`/oracoes/${number}`} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingV3 />} />
            <Route path="/teste" element={<LandingTest />} />
            <Route path="/teste2" element={<LandingV3 />} />
            <Route path="/original" element={<Landing />} />
            <Route path="/oracoes" element={<OracoesIndex />} />
            <Route path="/oracoes/:number" element={<PrayerPage />} />
            <Route path="/oracao/:number" element={<LegacyPrayerRedirect />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/conversoes" element={<ProtectedRoute><AdminConversions /></ProtectedRoute>} />
            <Route path="/privacidade" element={<Privacidade />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
